import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Alert, Form, Row, Spinner } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { updateBannerThreeInfoCard } from '../../../Common/data/updateBannerThreeInfoCard'; // Update import
import { getBannerThreeInfoCard, BannerThreeInfoCard as BannerThreeData } from '../../../Common/data/bannerThreeInfoCard'; // Update import

const BannerThreeInfoCard = () => {
    const [formData, setFormData] = useState({
        updatedBy: 'Admin',
        pageStatus: '2',
        pageID: '8b9273e7-41ac-45fc-8227-474ea03fac3b',
        pageName: '',
        pageContent: '',
    });
    const [successAlert, setSuccessAlert] = useState(false);
    const [bannerThreeData, setBannerThreeData] = useState<BannerThreeData | undefined>(undefined); // Update state name
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent<HTMLButtonElement>) => {
        e.preventDefault();

        setProcessing(true);
        setError('');

        try {
            const updatedData = {
                ...formData,
                pageName: getElementValue('banner-title-input'),
                pageContent: formData.pageContent,
            };

            console.log('Updated BannerThree Info Data:', updatedData);

            await updateBannerThreeInfoCard(updatedData);

            console.log('BannerThree Info updated successfully!');
            setSuccessAlert(true);

            // Hide the success alert after 3 seconds
            setTimeout(() => {
                setSuccessAlert(false);
            }, 3000);
        } catch (error: any) {
            console.error('Error updating BannerThree Info:', error.message);
        } finally {
            setProcessing(false);
        }
    };

    const getElementValue = (elementId: string): string => {
        const element = document.getElementById(elementId);

        if (element && 'value' in element) {
            return element.value as string;
        }

        return '';
    };

    const fetchBannerThreeDetails = async () => {
        try {
            const data = await getBannerThreeInfoCard();
            setBannerThreeData(data);
        } catch (error: any) {
            console.error('Error fetching Banner Three Info Card details:', error.message);
        }
    };

    useEffect(() => {
        // Fetch banner three details when the component mounts
        fetchBannerThreeDetails();
    }, []); // Empty dependency array ensures the effect runs only once

    return (
        <Card>
            <Card.Header>
                <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                            <div className="avatar-title rounded-circle custom-bg-light custom-text-primary fs-20">
                                <i className="bi bi-box-seam"></i>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-1">Banner Three Information</h5> {/* Update title */}
                        <p className="text-muted mb-0">Fill in all information below.</p>
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col lg={6}>
                        <div className="mb-3">
                            <Form.Label htmlFor="banner-title-input">Title</Form.Label>
                            <Form.Control
                                type="text"
                                id="banner-title-input"
                                defaultValue={bannerThreeData?.pageName}
                                placeholder="Enter a title"
                                required
                                onChange={(e) => setFormData({ ...formData, pageName: e.target.value })}
                            />
                            <div className="invalid-feedback">Please enter a title.</div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                            <Form.Label htmlFor="banner-content-input">Content</Form.Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={bannerThreeData?.pageContent || ''}
                                onReady={(editor: any) => {
                                    // You can store the "editor" and use it when needed.
                                }}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>, editor: any) => {
                                    if (editor) {
                                        const content: string = editor.getData();
                                        setFormData({ ...formData, pageContent: content });
                                    }
                                }}
                            />
                            <div className="invalid-feedback">Please enter content.</div>
                        </div>
                    </Col>
                </Row>

                {error && <Alert variant="danger">{error}</Alert>}
                {successAlert && (
                    <Alert variant="success" onClose={() => setSuccessAlert(false)} dismissible>
                        <p>BannerThree Info updated successfully!</p> {/* Update success message */}
                    </Alert>
                )}
                <Button type="submit" variant="primary" onClick={handleSubmit}>
                    {processing ? <Spinner animation="border" size="sm" /> : 'Save Changes'}
                </Button>
            </Card.Body>
        </Card>
    );
};

export default BannerThreeInfoCard;
